/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { RouteObject } from 'react-router'
import MandateFormPage from './MandateFormPage'
import MandateListPage from './MandateListPage'

export const mandateRoutes: RouteObject[] = [
  {
    index: true,
    element: <MandateListPage />
  },
  {
    path: 'create',
    element: <MandateFormPage />
  },
  {
    path: ':id/*',
    children: [
      {
        path: 'edit',
        element: <MandateFormPage />
      }
    ]
  }
]
